import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useIpAddressWhitelistDeleteConfirmModal = () => {
  const { t } = useTranslation();

  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('ip_address_whitelist_delete_modal_title'),
      body: t('ip_address_whitelist_delete_modal_description'),
      size: 'md',
      cancelButtonProps: {
        isSecondary: true,
        children: t('cancel'),
        size: 'sm',
      },
      okButtonProps: {
        color: 'danger',
        children: t('delete'),
        size: 'sm',
      },
    }),
    [t]
  );

  return useConfirmModal(args);
};
